import { Badge, Colour, ListItem } from '@ukpostbox/frontend-framework';
import React from 'react';

type HarmonySearchResultsType = {
	harmonyCodes?: any;
	selectedCallback: (id: string, type: string) => void;
};

function HarmonySearchResults(props: HarmonySearchResultsType) {
	return (
		<div>
			{props.harmonyCodes?.map((item: any) => (
				<ListItem
					key={`commodityEntry${item.id}`}
					hideArrow={item.type === 'Commodity'}
					onClick={() => props.selectedCallback(item.id, item.type)}
					addonLeft={item.type === 'Commodity' ? <Badge colour={Colour.Success} /> : undefined}
					title={`${item.title}`}
					description={item.type === 'Commodity' ? item.id : ''}
				/>
			))}
		</div>
	);
}

export { HarmonySearchResults };
